import { createContext } from 'react'
const chatbotContext = createContext()
export default chatbotContext